import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

createApp(App)
    .use(store)
    .use(router)
    .use(autoAnimatePlugin)
    .component('v-select', vSelect)/*.component('font-awesome-icon', FontAwesomeIcon)*/
.mount('#app')

